import placeholderIcon from '@SvgIcon/../event-image-placeholder.svg'

import each from 'lodash/each'
import $ from 'jquery'
import Vue from 'vue'
import Flickity from 'flickity'
import imagesLoaded from 'imagesloaded'

import EventInstanceModal from '../module/calendar/EventInstanceModal'
import { transformRawEvent } from '../module/calendar/transformRawEvent'
import { thumbUrlFromFileObject } from '../../shared/fileArrayUrl'
import svgIconHtml from '../../shared/svgIconHtml'

import '../../../scss/app/home.scss'

//
// Home panel audio
//

const homePanelAudio = document.getElementById('home-panel-audio')
const homePanelAudioToggle = document.getElementById('home-panel-audio-toggle')

if (homePanelAudio && homePanelAudioToggle) {
  const $playIcon = $(homePanelAudioToggle).find('.play')
  const $pauseIcon = $(homePanelAudioToggle).find('.pause')
  homePanelAudio.addEventListener('pause', () => {
    $playIcon.removeClass('visible')
    $pauseIcon.addClass('visible')
  })
  homePanelAudio.addEventListener('play', () => {
    $playIcon.addClass('visible')
    $pauseIcon.removeClass('visible')
  })
  if (homePanelAudio.hasAttribute('data-autoplay')) {
    homePanelAudio.play()
  }
  homePanelAudioToggle.addEventListener('click', () => {
    if (homePanelAudio.paused) {
      homePanelAudio.play()
    } else {
      homePanelAudio.pause()
    }
  })
}

//
// Home panel slider
//

const app = document.getElementById('app')

// eslint-disable-next-line no-shadow
function resizeBackgroundVideo(videoWrap, availableWidth, availableHeight) {
  if (!videoWrap) {
    return
  }
  const videoDims = videoWrap.getBoundingClientRect()
  const videoAr = videoDims.width / videoDims.height
  if (videoDims.height < availableHeight) {
    videoWrap.style.width = `${availableHeight * videoAr}px`
  }
  if (videoDims.width < availableWidth) {
    videoWrap.style.width = `${availableWidth}px`
    videoWrap.style.height = `${availableWidth / videoAr}px`
  }
}

function resizePanel(panelWrap) {
  if (!panelWrap) {
    return
  }

  let panelDims = panelWrap.getBoundingClientRect()
  // Convert to a normal object so we can override a prop later. (IE11 complains otherwise.)
  panelDims = $.extend({}, panelDims)

  let availableHeight = Math.min(
    $(window).height() - (app.getBoundingClientRect().top + window.pageYOffset),
    800, // also adjust in home.scss -> .home-panel-wrap
  )

  const announcements = document.querySelectorAll('.announcement-wrap')
  each(announcements, (el) => {
    availableHeight -= el.offsetHeight
  })

  panelWrap.style.height = `${availableHeight}px`
  panelDims.height = availableHeight

  const bgVideoContainer = panelWrap.querySelector('.home-panel__bg .video-container')
  if (bgVideoContainer) {
    bgVideoContainer.style.height = `${availableHeight}px`

    const bgVideoWrap = bgVideoContainer.querySelector('.video-wrap')
    if (bgVideoWrap) {
      resizeBackgroundVideo(bgVideoWrap, panelDims.width, panelDims.height)
    }
  }

  const panelText = panelWrap.querySelector('.home-panel__content-above-video')
  const panelIcons = panelWrap.querySelector('.home-panel__icons')

  const doMargins = () => {
    if (panelText) {
      panelText.style.marginTop = 0
      panelText.style.marginBottom = 0
      const textHeight = panelText.getBoundingClientRect().height
      const iconsHeight = panelIcons ? panelIcons.getBoundingClientRect().height : 0
      const totalWhitespace = panelDims.height - iconsHeight - textHeight - 30
      panelText.style.marginTop = `${totalWhitespace / 2}px`
      panelText.style.marginBottom = `${totalWhitespace / 2}px`
    }
  }

  if (panelIcons) {
    imagesLoaded(panelIcons, doMargins)
  } else {
    doMargins()
  }
}

function playAnimations(panelWrap, classNamePrefix) {
  if (!panelWrap) {
    return new Promise((resolve) => {
      resolve()
    })
  }

  return new Promise((resolve) => {
    const animationElements = panelWrap.querySelectorAll(`[class*="${classNamePrefix}animate__"]`)
    if (!animationElements.length) {
      resolve()
      return
    }

    let numAnimationsRunning = animationElements.length

    each(animationElements, (animateEl) => {
      const onAnimationEnd = () => {
        numAnimationsRunning -= 1
        animateEl.removeEventListener('animationend', onAnimationEnd)

        // Restore the original class name
        if ('app__origClassName' in animateEl) {
          animateEl.className = animateEl.app__origClassName
        }

        if (numAnimationsRunning <= 0) {
          resolve()
        }
      }

      /** @var Element animateEl */
      animateEl.addEventListener('animationend', onAnimationEnd)

      // Restore the original class name to eliminate any existing animations.
      if ('app__origClassName' in animateEl) {
        animateEl.className = animateEl.app__origClassName
      }
      // Store the original class name so we can reset the animations.
      animateEl.app__origClassName = animateEl.className

      // Play the animations
      const re = RegExp(`(${classNamePrefix}([^\\s]+))`, 'ig')
      const newClassName = animateEl.className.replace(
        re,
        (fullMatch, fullClassName, actualClassName) => actualClassName,
      )
      animateEl.className = `${newClassName} animate__animated`
    })
  })
}

function onPanelEnter(panelWrap) {
  if (!panelWrap) {
    return
  }

  if (panelWrap.hasAttribute('data-move-icon-bar')) {
    const iconBar = document.querySelector('.action-icons')
    if (iconBar && !panelWrap.querySelector('.action-icons')) {
      panelWrap.querySelector('.home-panel__content .cms-ve').appendChild(iconBar)
      iconBar.className += ' home-panel__icons'
    }
  }

  playAnimations(panelWrap, 'enter-').then()

  each(panelWrap.querySelectorAll('video'), (video) => {
    if (video.hasAttribute('data-src')) {
      video.setAttribute('src', video.getAttribute('data-src'))
      video.removeAttribute('data-src')
    }
  })

  resizePanel(panelWrap)
}

function initHome() {
  const panelsContainer = document.querySelector('.home-panels')
  const panelSelector = '.home-panel-wrap'

  if (panelsContainer) {
    // Initialize existing panels:
    const existingPanels = panelsContainer.querySelectorAll(panelSelector)
    if (existingPanels.length) {
      each(existingPanels, (panelWrap) => {
        resizePanel(panelWrap)
        $(window).on('resize', () => {
          resizePanel(panelWrap)
        })
      })
    }

    const $panelsContainer = $(panelsContainer)

    // Try to prevent drastic page height shifts:
    $panelsContainer.addClass('is-slider-initializing')

    let autoplayTimeout = null
    let autoplayTimeoutPausedByVisibilityChange = false

    /*
     * Flickity applies [aria-hidden="true"] to off-screen slides.
     *
     * https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus?application=axeAPI
     * aria-hidden elements should not contain focusable elements.
     *
     * To fix this, I'll manually declare tabindex -1 on off-screen elements and remove it
     * when they enter the viewport.
     *
     * This means I can't hard-code any tabindex within slides, but it's an acceptable trade-off for now.
     */
    const makeOnlyVisiblePanelsFocusable = (flkty) => {
      const focusableElemsSelector = 'a, button, input, textarea, [tabindex=0], select'
      $panelsContainer.find(panelSelector).each((i, panel) => {
        $(panel).find(focusableElemsSelector).attr('tabindex', '-1')
      })
      flkty.selectedElements.forEach((panel) => {
        $(panel).find(focusableElemsSelector).removeAttr('tabindex')
      })
    }

    const flkty = new Flickity(panelsContainer, {
      cellSelector: panelSelector,
      contain: true,
      dragThreshold: 40,
      // We set up our own prev/next buttons:
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      on: {
        change() {
          makeOnlyVisiblePanelsFocusable(this)
        },
        ready() {
          $panelsContainer.removeClass('is-slider-initializing')

          makeOnlyVisiblePanelsFocusable(this)

          /**
           * @return HTMLButtonElement
           */
          const createButton = (className, ariaLabel, html) => {
            const arrow = document.createElement('button')
            arrow.className = `slider-btn ${className}`
            arrow.type = 'button'
            arrow.setAttribute('aria-label', ariaLabel)
            arrow.innerHTML = html
            return arrow
          }

          // eslint-disable-next-line arrow-body-style
          const goNext = () => {
            // Nick doesn't like the flash of original state seen on a panel as it's sliding out.
            // So, I'm removing exit animation entirely.
            // return playAnimations(this.selectedElement, 'exit-').then(() => {
            //   this.next(true);
            // });
            return new Promise((resolve) => {
              this.next(true)
              resolve()
            })
          }

          // eslint-disable-next-line arrow-body-style
          const goPrev = () => {
            // Nick doesn't like the flash of original state seen on a panel as it's sliding out.
            // So, I'm removing exit animation entirely.
            // return playAnimations(this.selectedElement, 'exit-').then(() => {
            //   this.previous(true);
            // });
            return new Promise((resolve) => {
              this.previous(true)
              resolve()
            })
          }

          if (panelsContainer.querySelectorAll(panelSelector).length > 1) {
            // Set up prev/next arrows:
            const prevArrow = createButton(
              'slider-btn-prev',
              'Previous slide',
              // eslint-disable-next-line max-len
              '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>',
            )
            prevArrow.onclick = () => {
              clearTimeout(autoplayTimeout)
              goPrev().then()
            }

            const nextArrow = createButton(
              'slider-btn-next',
              'Next slide',
              // eslint-disable-next-line max-len
              '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>',
            )
            nextArrow.onclick = () => {
              clearTimeout(autoplayTimeout)
              goNext().then()
            }

            const buttonsFragment = document.createDocumentFragment()
            buttonsFragment.appendChild(prevArrow)
            buttonsFragment.appendChild(nextArrow)
            panelsContainer.appendChild(buttonsFragment)
          }

          $(panelSelector).removeClass('is-slider-initializing')
          if (existingPanels.length) {
            onPanelEnter(Array.from(existingPanels)[0])
          }

          // Timeout so that exit animations have a chance to play.
          const nextTimeout = () => {
            const showForSeconds = parseInt(this.selectedElement.getAttribute('data-show-for'), 10)
            autoplayTimeout = setTimeout(async () => {
              await goNext()
              nextTimeout()
            }, !Number.isNaN(showForSeconds) && showForSeconds > 0 ? showForSeconds * 1000 : 5500)
          }
          nextTimeout()

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden' || document.hidden) {
              if (autoplayTimeout) {
                autoplayTimeoutPausedByVisibilityChange = true
              }
              clearTimeout(autoplayTimeout)
            } else if (autoplayTimeoutPausedByVisibilityChange) {
              autoplayTimeoutPausedByVisibilityChange = false
              nextTimeout()
            }
          })
        },
      },
    })

    flkty.on('dragStart', () => {
      clearTimeout(autoplayTimeout)
    })

    flkty.on('change', () => {
      onPanelEnter(flkty.selectedElement)
    })

    // Observe new panels:

    const panelObserver = new MutationObserver((mutations) => {
      each(mutations, (mutation) => {
        each(mutation.addedNodes, (node) => {
          if (node.nodeType !== 1) {
            return
          }

          const panels = node.querySelectorAll(panelSelector)
          if (!panels.length) {
            return
          }

          each(panels, (panelWrap) => {
            resizePanel(panelWrap)
          })
        })
      })
    })

    panelObserver.observe(panelsContainer, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    })
  }

  $(window).on('resize', () => {
    const panels = document.querySelectorAll(panelSelector)
    if (!panels.length) {
      return
    }

    each(panels, (panelWrap) => {
      resizePanel(panelWrap)
    })
  })
}

if (module.hot) {
  $(window).on('load', initHome)
} else {
  initHome()
}

//
// Events
//

const eventsAppContainer = document.querySelector('.js-events')
if (eventsAppContainer) {
  new Vue({
    components: {
      EventInstanceModal,
    },
    name: 'EventsWidget',
    el: eventsAppContainer,
    props: {
      events: Array,
    },
    propsData: {
      events: JSON.parse(eventsAppContainer.dataset.events).map(transformRawEvent),
    },
    template: `
      <div class="event-widget">
        <p v-if="events.length === 0" class="text-center">
          Nothing scheduled. Check back soon!
        </p>
        <div v-else class="event-widget__events">
          <button
              v-for="event in events"
              class="event-widget__event"
              @click="viewEvent(event)"
          >
            <div class="event-widget__event-photo is-custom-photo" v-if="eventPhotoThumbUrl(event)">
              <img :src="eventPhotoThumbUrl(event)" alt="">
              <template v-else>${svgIconHtml(placeholderIcon)}</template>
            </div>
            <div class="event-widget__event-photo is-default-photo" v-else>
              ${svgIconHtml(placeholderIcon)}
            </div>
            <div class="event-widget__event-date">
              <div class="start date">
                <div class="month">{{ event.dateStartMoment.format('MMM') }}</div>
                <div class="day">{{ event.dateStartMoment.format('D') }}</div>
              </div>
              <div class="end date" v-if="event.dateStart !== event.dateEnd">
                <div class="month">{{ event.dateEndMoment.format('MMM') }}</div>
                <div class="day">{{ event.dateEndMoment.format('D') }}</div>
              </div>
            </div>
            <div class="event-widget__event-info">
              <div class="event-widget__event-title">{{ event.title }}</div>
              <div v-if="event.cancelled" class="event-widget__event-cancelled">Cancelled!</div>
            </div>
          </button>
        </div>
        <EventInstanceModal ref="modal" />
      </div>
    `,
    methods: {
      viewEvent(event) {
        this.$refs.modal.show(event.title, event.dataUrl)
      },

      eventPhotoThumbUrl(event) {
        return thumbUrlFromFileObject(event.photo)
      },
    },
  })
}
